import { render, staticRenderFns } from "./InvestmentList.vue?vue&type=template&id=7530c700&scoped=true"
import script from "./InvestmentList.vue?vue&type=script&lang=js"
export * from "./InvestmentList.vue?vue&type=script&lang=js"
import style0 from "./InvestmentList.vue?vue&type=style&index=0&id=7530c700&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7530c700",
  null
  
)

export default component.exports